"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResourceBrowser = exports.SourceDropdownContainer = exports.SourceDropdown = exports.BrowseToSource = exports.AuthContext = exports.AuthProvider = exports.useAuthContext = exports.ResourceBrowserContextProvider = exports.ResourceBrowserContext = void 0;
const react_1 = __importStar(require("react"));
const ResourceBrowserContext_1 = require("./ResourceBrowserContext/ResourceBrowserContext");
Object.defineProperty(exports, "ResourceBrowserContext", { enumerable: true, get: function () { return ResourceBrowserContext_1.ResourceBrowserContext; } });
Object.defineProperty(exports, "ResourceBrowserContextProvider", { enumerable: true, get: function () { return ResourceBrowserContext_1.ResourceBrowserContextProvider; } });
const useSources_1 = require("./Hooks/useSources");
const Plugin_1 = require("./Plugin/Plugin");
const AuthProvider_1 = require("./ResourceBrowserContext/AuthProvider");
Object.defineProperty(exports, "AuthProvider", { enumerable: true, get: function () { return AuthProvider_1.AuthProvider; } });
Object.defineProperty(exports, "useAuthContext", { enumerable: true, get: function () { return AuthProvider_1.useAuthContext; } });
Object.defineProperty(exports, "AuthContext", { enumerable: true, get: function () { return AuthProvider_1.AuthContext; } });
const BrowseToSource_1 = __importDefault(require("./BrowseToSource/BrowseToSource"));
exports.BrowseToSource = BrowseToSource_1.default;
const SourceDropdown_1 = __importDefault(require("./SourceDropdown/SourceDropdown"));
exports.SourceDropdown = SourceDropdown_1.default;
const SourceDropdownContainer_1 = __importDefault(require("./SourceDropdownContainer/SourceDropdownContainer"));
exports.SourceDropdownContainer = SourceDropdownContainer_1.default;
__exportStar(require("./types"), exports);
const ResourceBrowser = (props) => {
    const { value, inline, inlineType } = props;
    const [error, setError] = (0, react_1.useState)(null);
    const { onRequestSources, searchEnabled, plugins } = (0, react_1.useContext)(ResourceBrowserContext_1.ResourceBrowserContext);
    const [isModalOpen, setIsModalOpen] = (0, react_1.useState)(false);
    const [source, setSource] = (0, react_1.useState)(null);
    const [mode, setMode] = (0, react_1.useState)(null);
    const { data: sources, isLoading, error: sourcesError } = (0, useSources_1.useSources)({ onRequestSources, plugins });
    const [plugin, setPlugin] = (0, react_1.useState)(null);
    // MainContainer will render a list of sources of one is not provided to it, callback to allow it to set the source once a user selects
    const handleSourceSelect = (0, react_1.useCallback)((source, mode) => {
        setSource(source);
        setMode(mode || null);
    }, [setSource, setMode]);
    // If an existing resource is passed in auto select its source
    (0, react_1.useEffect)(() => {
        let source = null;
        setError(null);
        // If there is a provided value try to use its source
        if (value) {
            // Search the sources for it matching against the value.source property
            source = sources.find((source) => source.id === value?.sourceId) || null;
            // If the source is null and we arent loading the sources
            if (source === null && !isLoading) {
                // Set an error as the passed in value's source wasnt returned by onRequestSources
                setError(new Error('Unable to find resource source.'));
            }
        }
        else if (sources?.length === 1 && !searchEnabled) {
            // If only one source is passed and search is not enabled select it automatically
            source = sources[0];
        }
        setSource(source);
        setMode(null); // Passed in resource will always use the default mode
    }, [value, isLoading, sources, setSource, setError]);
    // When a source is selected update our plugin reference to match (legacy support)
    // the plugin is now attached to the source directly when fetched from the context so use that instead when possible
    (0, react_1.useEffect)(() => {
        if (source?.plugin) {
            setPlugin(source.plugin);
        }
        else {
            setPlugin(null);
        }
    }, [plugins, source]);
    // The modal has some control over it own open/closed state (for WCAG reasons) so keep this in sync with our state
    const handleModalStateChange = (0, react_1.useCallback)((isOpen) => {
        setIsModalOpen(isOpen);
    }, [setIsModalOpen]);
    // If the modal closes and we dont have a value clear the source state so it goes back to the launcher on re-open
    (0, react_1.useEffect)(() => {
        if (!isModalOpen && !value && (sources?.length > 1 || searchEnabled)) {
            setSource(null);
            setMode(null);
        }
    }, [sources, isModalOpen]);
    // Render a default "plugin" and one for each item in the plugins array. They are conditionally rendered based on what is selected
    return (react_1.default.createElement("div", { className: "squiz-rb-scope" },
        react_1.default.createElement(Plugin_1.PluginRender, { key: "default", render: plugin === null, inline: !!inline, inlineType: inlineType, ...props, source: source, sources: sources, setSource: handleSourceSelect, isLoading: isLoading, error: sourcesError || error, plugin: plugin, pluginMode: mode, searchEnabled: searchEnabled, useResource: () => {
                return {
                    data: null,
                    error: null,
                    isLoading: false,
                };
            }, isModalOpen: isModalOpen, onModalStateChange: handleModalStateChange }),
        plugins.map((thisPlugin) => {
            return (react_1.default.createElement(Plugin_1.PluginRender, { key: thisPlugin.type, render: thisPlugin === plugin, inline: !!inline, inlineType: inlineType, ...props, source: source, sources: sources, setSource: handleSourceSelect, isLoading: isLoading, error: error, plugin: plugin, pluginMode: mode, searchEnabled: searchEnabled, useResource: thisPlugin.useResolveResource, isModalOpen: isModalOpen, onModalStateChange: handleModalStateChange }));
        })));
};
exports.ResourceBrowser = ResourceBrowser;
